import React from 'react';
import { VerticalListing, BlockLink } from '@hz-design-system/web-ui';

type TFeedItemProps = {
  className: string;
  imageUrl: string;
  price: string;
  title: string;
  url: string;
};

const Ad = ({ className, imageUrl, price, title, url }: TFeedItemProps) => {
  return (
    <BlockLink className={className} href={url} target="_blank">
      <VerticalListing title={title} price={price} imageSrc={imageUrl} imageLoading={'lazy'} />
    </BlockLink>
  );
};

export default Ad;
